import { formatToNumber } from './StringFormatHelper';

export const getWealthLevelIds = value => {
    const integerValue = formatToNumber(value);

    if (!integerValue || isNaN(integerValue)) {
        return '';
    }

    if (integerValue < 50000) {
        return '402';
    }

    if (integerValue < 100000) {
        return '402, 403';
    }

    if (integerValue < 250000) {
        return '402, 403, 404';
    }

    if (integerValue < 500000) {
        return '402, 403, 404, 405';
    }

    if (integerValue < 1000000) {
        return '402, 403, 404, 405, 406';
    }

    return '402, 403, 404, 405, 406, 653';
};

export const getMortgageValueIds = value => {
    const val = value.replace(/[^\w\s]/g, '');
    const integerValue = parseInt(val);
    if (!integerValue || isNaN(integerValue)) {
        return '';
    }

    if (integerValue < 50000) {
        return '408';
    }

    if (integerValue < 100000) {
        return '408,587';
    }

    if (integerValue < 250000) {
        return '408,587,409';
    }

    if (integerValue < 500000) {
        return '408,587,409,410';
    }

    if (integerValue < 1000000) {
        return '408,587,409,410,411';
    }

    return '408,587,409,410,411,412';
};

export const getDataAsJSON = params => {
    const requestData = {
        advice_area: !isNaN(parseInt(params.adviceArea)) ? parseInt(params.adviceArea) : 393,
        message: params.message,
        vertical: 5,
        source: params.utm ? params.utm : 'discover',
        customer: {
            name: params.fullName,
            email: params.email,
            phone: params.phone,
            postcode: params.postcode,
        },
        isLocationImportant: params.isLocationImportant 
    };

    if (params.adviceArea !== 392) {
        requestData.wealth_level = formatToNumber(params.wealthLevel);
        requestData.telephony_advice = false;
    } else {
        const depositValue = formatToNumber(params.deposit);
        const mortgageValue = formatToNumber(params.mortgageValue);

        requestData.mortgage_value = mortgageValue - depositValue;
        requestData.annual_income = formatToNumber(params.annualIncome);
        requestData.deposit = depositValue;
        requestData.advice_time = params.adviceTime;
    }

    return requestData;
};
